import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2022 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

/*
This must be set to true BEFORE any classes that are annotated as @container (like AbVdlTSVDLCmp) are LOADED.
Otherwise, the annotation will be muted and the identity of all components on the page will be severely truncated
(Page_FacetedSearchViewer vs. Page_ConfigurationView.innerBox.mainContent.main.mainContentArea.ConfigureUIConfigurations.main.uiFacetedSearch_FacetedSearchViewer

See AbVdlTSVDLCmp and IdentityUtils for more details.
*/
import { ProductInfo } from "abweb/dto/product/ProductInfo";
document._abInitioGlobalConfig = {
  pageStateReloadEnabled: true
};

// IMPORTANT: ORDER MATTERS FOR OUR CSS :( CSS imports are each on a new line to help prevent auto import organization in editors
import "abweb/assets/styles/CssLib"; // DO NOT RE-ORDER!!!!

import "abreact/assets/styles/CssLib"; // DO NOT RE-ORDER!!!!

import "abprofileviewer/assets/styles/CssLib"; // DO NOT RE-ORDER!!!!

import "abmtweb/assets/styles/CssLib"; // DO NOT RE-ORDER!!!!

import "abaicentral/assets/styles/CssLib"; // DO NOT RE-ORDER!!!!

import "abbre/assets/styles/CssLib"; // DO NOT RE-ORDER!!!!

import "abdsc/assets/styles/CssLib"; // DO NOT RE-ORDER!!!!

import "abeicommons/assets/styles/CssLib"; // DO NOT RE-ORDER!!!!

import "abei/assets/styles/CssLib"; // DO NOT RE-ORDER!!!!

import "abcc/assets/styles/CssLib"; // DO NOT RE-ORDER!!!!

import "abez/assets/styles/CssLib"; // DO NOT RE-ORDER!!!!

import "abqi/assets/styles/CssLib"; // DO NOT RE-ORDER!!!!

import "abmhub/assets/styles/CssLib"; // DO NOT RE-ORDER!!!!

import "abag/assets/styles/CssLib"; // DO NOT RE-ORDER!!!!

import "abentity/assets/styles/CssLib"; // DO NOT RE-ORDER!!!!

import "abvdl/assets/styles/CssLib"; // DO NOT RE-ORDER!!!!

import "abportal/assets/styles/CssLib"; // DO NOT RE-ORDER!!!!

import "abtrwapp/assets/styles/CssApp"; // DO NOT RE-ORDER!!!!

import "cafe/assets/styles/CssLib"; // DO NOT RE-ORDER!!!!
// IMPORTANT: ORDER MATTERS FOR OUR CSS :(

import { abaicentralModules } from "abaicentral/generated/ModuleIndex";
import { abdscModules } from "abdsc/generated/ModuleIndex";
import { abentityModules } from "abentity/generated/ModuleIndex";
import { abmtwebModules } from "abmtweb/generated/ModuleIndex";
import { abportalModules } from "abportal/generated/ModuleIndex";
import { AbPortalHelpService } from "abportal/service/AbPortalHelpService";
import { abprofileviewerModules } from "abprofileviewer/generated/ModuleIndex";
import { abqiModules } from "abqi/generated/ModuleIndex";
import { AbBannerProvider } from "abreact/app/banner/AbBannerProvider";
import { AbDefaultThemingService } from "abreact/app/theming/AbDefaultThemingService";
import { abreactModules } from "abreact/generated/ModuleIndex";
import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { AbReactServices } from "abreact/service/AbReactServices";
import { AbAlert } from "absdk/commons/ui/popup/AbAlert";
import { bootstrapApp, generateBootstrapAppLoaderFn } from "absdk/preliminary/framework/app/AbApplicationBootstrap";
import { ModuleListFilesExtensionPoint } from "absdk/preliminary/framework/app/AbPortalBootstrapExtensionPoints";
import { AbPortalExtensions } from "absdk/preliminary/portal/plugin/AbPortalPlugin";
import { extensionSetThirdPartyModules } from "abvdl/utils/ExtensionSetThirdPartyModules";
import { RemoteError } from "abweb/dto/exception/RemoteError";
import { ProductInfoItem } from "abweb/dto/product/ProductInfoItem";
import { abwebModules } from "abweb/generated/ModuleIndex";
import { AbWebServices } from "abweb/service/AbWebServices";
import { FailedToFetchError } from "abweb/service/utils/rpc/FailedToFetchError";
import { FetchUtils, StatusCode } from "abweb/service/utils/rpc/FetchUtils";
import { BrowserUtils } from "abweb/utils/BrowserUtils";
import { ClassUtils } from "abweb/utils/ClassUtils";
import { ModuleLoaderUtils } from "abweb/utils/ModuleLoaderUtils";
import { LogAndRenderErrorPipeline } from "abweb/utils/error/LogAndRenderErrorPipeline";
import { loadModule } from "abweb/utils/plugins/DynamicModuleLoader";
import { abModuleRegistry } from "abweb/utils/plugins/ModuleRegistry";
import { initializer } from "abweb/utils/plugins/Plugins";
import { ProfileUtils } from "abweb/utils/profile/ProfileUtils";
import { cafeModules } from "cafe/generated/ModuleIndex";
import { EntityUserSettingsStorage } from "abentity/service/EntityUserSettingsStorage";
import { UserSettingsService } from "abweb/service/settings/UserSettingsService";
const PORTAL_DEFAULT_THEME_TWEAKS = [];

// Register all modules that could possibly be imported from dynamically loaded plugins.
// TODO: this list should be more complete.
abModuleRegistry.registerModules({
  ...abreactModules,
  ...abwebModules,
  ...abmtwebModules,
  ...abprofileviewerModules,
  ...abdscModules,
  ...abaicentralModules,
  ...abentityModules,
  ...abqiModules,
  ...abportalModules,
  ...cafeModules,
  // TODO: need more third party modules
  ...extensionSetThirdPartyModules
});
function pluginAdapter(pluginOrLoader) {
  if ("id" in pluginOrLoader) {
    // already a plugin
    return pluginOrLoader;
  } else if ("plugin" in pluginOrLoader) {
    // already a plugin (exported)
    return pluginOrLoader.plugin;
  }
  throw new Error("expected a Plugin or ExportedPlugin");
}
/**
 *
 * @param portalLoader
 * @param productInfoImportFn
 * @param portalInstancePreloadSpecs if undefined, it will default to a single preload spec that imports the provided portalLoader
 * module.  Otherwise, it uses the provided portalInstancePreloadSpecs as provided.
 */
export async function bootstrapPortal(portalLoader, options = {}) {
  const portalInstancePreloadSpecs = options.portalInstancePreloadSpecs ?? [ModuleLoaderUtils.createImportSpec(portalLoader, "loadPortal")];
  // Resulting PortalApplication Chunk size is approx. 1MB, taking roughly 943 msec to fetch if not cached
  // Note really a win to have finer-grained fetches of the PortalApplication imports if all are in webpackChunkName: PortalApplication
  // as only the first finer-grained import spec will cause a network prefetch.  So just load PortalApplication for now
  const portalApplicationSpec = ModuleLoaderUtils.createImportSpec(() => import(/* webpackChunkName: "PortalApplication" */"cafe/portal/PortalApplication"), "PortalApplication");

  // These specs are automatically appended to AbAppLoaderPreloadSpecs.abAppLoaderPreloadSpecs (base absdk app preload specs)
  const portalPreloadSpecs = [portalApplicationSpec,
  // Portal implementation specific preload specs
  ...portalInstancePreloadSpecs];
  const preAuthFn = async alProps => {
    try {
      if (options.productInfoImportFn) {
        const clientProductInfo = await options.productInfoImportFn();
        AbWebServices.sessionData.set("clientProductInfo", clientProductInfo);
        if (clientProductInfo?.officialName) {
          AbWebServices.sessionData.productInfo.officialName = clientProductInfo?.officialName;
        }
      } else {
        const configuredName = __RUNTIME_ENV__.ABSDK_APP_FULL_NAME ?? "Portal";
        const projectVersion = __RUNTIME_ENV__.ABSDK_APP_PROJECT_VERSION ?? "";
        const buildTimestamp = __RUNTIME_ENV__.ABSDK_APP_BUILD_TIMESTAMP ?? "";
        const emptyProductInfo = ProductInfo.createEmptyProductInfo();
        const defaultClientProductInfo = ProductInfo.createProductInfo(emptyProductInfo.allowGuestAccess, emptyProductInfo.buildID, buildTimestamp, emptyProductInfo.helpModule, [ProductInfoItem.createProductInfoItem("Build Date", buildTimestamp),
        // Portals have no single build ID since they are currently made up of a p4 changelist + git project hashes. We
        // will display an empty string for protals that do not decide what this value should be for themselves. Including
        // an empty string allows the Cafe build ID to be shown as "Server Build ID".
        ProductInfoItem.createProductInfoItem("Build ID", "")], configuredName, emptyProductInfo.productVersion, emptyProductInfo.usesUserAuthentication, projectVersion);
        AbWebServices.sessionData.set("clientProductInfo", defaultClientProductInfo);
      }
    } catch (e) {
      // missing client info, or JSON parse error. Just a warning.
      console.warn(e);
    }
    await options.preAuthHook?.(alProps);
  };

  // portalStartAppFn is invoked AFTER user has successfully been authenticated
  // Defer registering extension points until after user logs in,
  // as otherwise significantly delays login dialog display by about 424ms on a fast network
  const portalStartAppFn = async function startPortalApp(alProps) {
    // Currently there are no extension points that modify anything in workflow before login, so safe to put after login.
    await ProfileUtils.elapsedAsync("Startup: AbPortalBootstrap::registerExtensionPoints", () => registerExtensionPoints(portalLoader()));
    const baseStartAppFn = generateBootstrapAppLoaderFn(portalApplicationSpec.importModuleFn, portalApplicationSpec.exportName);
    return baseStartAppFn(alProps);
  };
  const bannerProvider = new AbBannerProvider();
  bannerProvider.productNameSupported = false; // ABSDK-2399: suppress product name for portal login dialog

  const themingService = new AbDefaultThemingService({
    defaultThemeTweakClassnames: PORTAL_DEFAULT_THEME_TWEAKS
  });
  const abReactServicesConfig = {
    bannerProvider,
    themingService
  };
  return bootstrapApp({
    startApp: portalStartAppFn,
    appPreloadSpecs: portalPreloadSpecs,
    abReactServicesConfig,
    abWebServicesConfig: {
      helpService: new AbPortalHelpService(),
      personaService: new ExtendablePersonaService(),
      userNavigationService: new ExtendableUserNavigationService(),
      userSettingsService: new UserSettingsService(new EntityUserSettingsStorage())
    },
    customErrorHandlers: [handleBadGatewayErrors, handleFailedToFetchErrors],
    preAuthHook: preAuthFn,
    portalLoginView: true
  });
}
class ExtendablePersonaService {
  constructor() {
    _defineProperty(this, "_loaded", void 0);
    _defineProperty(this, "personaChangeVetoCallback", void 0);
  }
  async load() {
    if (!this._loaded) {
      this._loaded = await AbPortalExtensions.PORTAL_PERSONA_SERVICE.get();
      this.personaChangeVetoCallback = this._loaded.personaChangeVetoCallback;
    }
    return this._loaded;
  }
  async getPersonas() {
    return (await this.load()).getPersonas();
  }
  async getMyPersonas() {
    return (await this.load()).getMyPersonas();
  }
  async setMyActivePersona(personaId) {
    return (await this.load()).setMyActivePersona(personaId);
  }
}
class ExtendableUserNavigationService {
  constructor() {
    _defineProperty(this, "_loaded", void 0);
  }
  async load() {
    if (!this._loaded) {
      this._loaded = await AbPortalExtensions.PORTAL_USER_NAVIGATION_SERVICE.get();
    }
    return this._loaded;
  }
  async getUserNavigation() {
    return (await this.load()).getUserNavigation();
  }
}
async function registerExtensionPoints(portalLoader) {
  const portal = await portalLoader;

  // accept either Plugin or ExternalPlugin
  const pluginLoaders = [
  // all plugins bundled into the application
  // eslint-disable-next-line @typescript-eslint/await-thenable
  ...(await Promise.all(portal.loadPortal())),
  // all plugins dynamically loaded 
  ...(await Promise.all((await getDynamicModuleList()).map(loadDynamicModule)))];
  const plugins = pluginLoaders.map(pluginAdapter);

  // initialize all plugins
  await initializer.initialize(plugins);
  const incompatiblePlugins = initializer.getIncompatiblePlugins();
  if (incompatiblePlugins.size > 0) {
    // TODO: 1) confirm we want this behavior 2) localization
    AbAlert.showError(Array.from(Array.from(incompatiblePlugins.values()).map(plugin => plugin.version ? `${String(plugin.id)}: ${plugin.version}` : `${String(plugin.id)}`)).join("\n"), `Incompatible Plugin${incompatiblePlugins.size > 1 ? "s" : ""}`);
  }
  await AbPortalExtensions.PORTAL_BOOTSTRAPPERS.dispatch();
}
const getProductName = () => {
  return AbWebServices.isInitialized() ? AbWebServices.sessionData.productInfo.name : "Ab Initio Portal Instance";
};
async function getDynamicModuleList() {
  try {
    const moduleFileList = await ModuleListFilesExtensionPoint.get();
    const moduleAddresses = [];
    for (const moduleFileName of moduleFileList) {
      const moduleConfig = await FetchUtils.fetchAndParseJson(moduleFileName);
      if (!("modules" in moduleConfig)) {
        throw new Error("Malformed module-list.json: must contain at least a 'modules' element");
      }
      moduleAddresses.push(...moduleConfig.modules);
    }
    return moduleAddresses;
  } catch (e) {
    console.warn("Unable to read list of dynamic modules");
    console.warn(e);
    return [];
  }
}

/**
 * Load a module dynamically, then verify that it exports a value named "plugin".
 */
async function loadDynamicModule(moduleAddress) {
  const module = await loadModule(moduleAddress);
  if (!("plugin" in module)) {
    throw new Error("Dynamically loaded module must have an export named 'plugin' of type Plugin");
  }
  return module;
}

// Handle case where nginx web server is running but underlying cafe is not (ABSDK-2532)
const handleBadGatewayErrors = function badGatewayErrorHandler(errCtx) {
  if (ClassUtils.isInstanceOf(errCtx?.error, RemoteError)) {
    const respStatus = errCtx.error.response?.status;
    if (respStatus && [StatusCode.BAD_GATEWAY, StatusCode.GATEWAY_TIMEOUT].includes(respStatus)) {
      // This error handler could be invoked before abreact services (and thus AbReactResources) are initialized,
      // so be defensive...
      const [title, message] = (() => {
        const productName = getProductName();
        if (AbReactServices.isInitialized()) {
          return [AbReactResources.gatewayErrorDlg_title(productName), AbReactResources.gatewayErrorDlg_message(productName)];
        }
        return [`${productName} Startup Failure`, `Could not start ${productName}. Please contact your Ab Initio accounts team or support@abinitio.com.`];
      })();
      displayCannotConnectError(errCtx, title, message);
      return true;
    }
  }
  return false;
};

// Handle case where the servers can not even be reached (so no response available), resulting in FailedToFetch errors.
// Details in PORTAL-13
const handleFailedToFetchErrors = function failedToFetchErrorHandler(errCtx) {
  if (ClassUtils.isInstanceOf(errCtx?.error, FailedToFetchError)) {
    // This error handler could be invoked before abreact services (and thus AbReactResources) are initialized,
    // so be defensive...
    const [title, message] = (() => {
      const productName = getProductName();
      if (AbReactServices.isInitialized()) {
        return [AbReactResources.failedToFetchErrorDlg_title(productName), AbReactResources.failedToFetchErrorDlg_message(productName)];
      }
      return [`${productName} Connection Failure`, `Could not connect to ${productName}. Please contact your Ab Initio accounts team or support@abinitio.com.`];
    })();
    displayCannotConnectError(errCtx, title, message);
    return true;
  }
  return false;
};
function displayCannotConnectError(errCtx, title, msg) {
  try {
    // Defensive: probably already logged, but just in case (debouncer will ensure it isn't logged twice)
    // Defensive: should not throw, but just in case....
    LogAndRenderErrorPipeline.pipeline.logError(errCtx.error);
  } catch (ignored) {
    // eslint-disable-next-line no-empty
  }
  const popupHandle = AbAlert.showError(msg, title);
  popupHandle.untilClosed.then(BrowserUtils.locationReload, BrowserUtils.locationReload);
}
//# sourceMappingURL=AbPortalBootstrap.js.map
